import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { InvoiceSummaryViewModel } from '../view-models/invoice-summary-view.model';

@Component({
    selector: 'app-invoice-summary-card',
    templateUrl: './invoice-card.component.html',
    styleUrls: ['./invoice-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceCardComponent {
  public readonly invoice = input<InvoiceSummaryViewModel>();
}
